export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "%0 z %1": "%0 of %1",
        "%0 znaków": "%0 characters",
        "<Brak nazwy>": "<No name>",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "${copied ? 'Copied' : 'Copy'}",
        "${el.text}": "${el.text}",
        "${getCurrentScope().label}": "${getCurrentScope().label}",
        "${item.entityName}": "${item.entityName}",
        "${item.text}": "${item.text}",
        "${props.inputPlaceholder}": "${props.inputPlaceholder}",
        "${str}": "${str}",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "${tokenVisibility ? 'Hide' : 'Show'} token",
        "1 godzina": "1 hour",
        "10 minut": "10 minutes",
        "12 godzin": "12 hours",
        "15 minut": "15 minutes",
        "24 godziny": "24 hours",
        "3 godziny": "3 hours",
        "30 minut": "30 minutes",
        "5 minut": "5 minutes",
        "6 godzin": "6 hours",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you must first save the form.",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "To test the validity of keys, first save the form.",
        "Adaptive sampling": "Adaptive sampling",
        "Administracja": "Administration",
        "Administracja - Kraje": "Administration - Countries",
        "Administracja - Miasta": "Administration - Cities",
        "Administracja - Role": "Administration - Roles",
        "Administracja - Stanowiska pracy": "Administration - Job positions",
        "Administracja - Użytkownicy": "Administration - Users",
        "Administracja - Województwa": "Administration - Provinces",
        "Administracja - Zespoły": "Administration - Teams",
        "Administratorzy": "Administrators",
        "Adres domenowy": "Domain address",
        "Adres e-mail potwierdzony": "Email address confirmed",
        "Adres email": "Email address",
        "Adres email nadawcy": "Sender's email address",
        "Adres IP": "IP address",
        "Adres IP: %0": "IP address: %0",
        "Akceptuj": "Accept",
        "Akcja": "Action",
        "Akcje": "Actions",
        "Aktualizacja: {0}": "Update: {0}",
        "Aktualizuj": "Update",
        "Aktualna sesja": "Current session",
        "Aktualne hasło": "Current password",
        "Aktualne urządzenie": "Current device",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywne kanały komunikacji": "Active communication channels",
        "Aktywne sesje": "Active sessions",
        "Aktywne źródła": "Active sources",
        "Aktywni": "Active",
        "Aktywny": "Active",
        "Alias": "Alias",
        "Alias został przepięty.": "Alias has been switched.",
        "Angielski": "English",
        "Anonimizuj": "Anonymize",
        "Anuluj": "Cancel",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "Application will restart within a maximum of 60 seconds.",
        "Application Insights": "Application Insights",
        "Aranżacja": "Arrangement",
        "Autor": "Author",
        "Azure AD": "Azure AD",
        "Azure Application Insights": "Azure Application Insights",
        "Basic Auth": "Basic Auth",
        "Bezpieczeństwo": "Security",
        "Bezpieczne połączenie SSL": "Secure SSL connection",
        "Blokada konta": "Account lock",
        "Blokada konta do": "Account lock until",
        "Blokowanie kont": "Account locking",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. Requested resource not found.",
        "Błąd w kodzie MJML.": "Error in MJML code.",
        "Błędne": "Invalid",
        "Błędy": "Errors",
        "Bool": "Bool",
        "Brak danych": "No data",
        "Brak elementów": "No items",
        "Brak kluczy": "No keys",
        "Brak nowych powiadomień.": "No new notifications.",
        "Brak opcji": "No options",
        "Brak wersji": "No version",
        "Brak wyboru": "No selection",
        "Brak wyników": "No results",
        "Brak zdefiniowanych ról.": "No roles defined.",
        "Brak zdefiniowanych zespołów.": "No teams defined.",
        "Bramka SMS": "SMS gateway",
        "Centrum powiadomień": "Notification center",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "Co 10 dni": "Every 10 days",
        "Co 10 minut": "Every 10 minutes",
        "Co 12 godzin": "Every 12 hours",
        "Co 15 minut": "Every 15 minutes",
        "Co 2 godziny": "Every 2 hours",
        "Co 2 minuty": "Every 2 minutes",
        "Co 2 tygodnie": "Every 2 weeks",
        "Co 20 minut": "Every 20 minutes",
        "Co 3 godziny": "Every 3 hours",
        "co 3 miesiące": "every 3 months",
        "Co 3 miesiące": "Every 3 months",
        "co 30 dni": "every 30 days",
        "Co 30 minut": "Every 30 minutes",
        "Co 4 miesiące": "Every 4 months",
        "Co 5 dni": "Every 5 days",
        "Co 5 minut": "Every 5 minutes",
        "Co 6 godzin": "Every 6 hours",
        "co 6 miesięcy": "every 6 months",
        "Co drugi dzień": "Every other day",
        "Co drugi miesiąc": "Every other month",
        "Co godzinę": "Every hour",
        "Co miesiąc": "Every month",
        "Co minutę": "Every minute",
        "Co pół roku": "Every half year",
        "co rok": "every year",
        "Co tydzień": "Every week",
        "Codziennie": "Daily",
        "Connection String": "Connection String",
        "Cron": "Cron",
        "Czas": "Time",
        "Czas nieaktywności użytkownika po którym zostanie wylogowany z panelu administracyjnego [min": "User inactivity time after which they will be logged out of the admin panel [min",
        "Czas trwania blokady": "Lock duration",
        "Czas uruchomienia": "Run time",
        "Czerwiec": "June",
        "Członkowie zespołu": "Team members",
        "Czy aby na pewno chesz zrestartować aplikacje?": "Are you sure you want to restart the application?",
        "Czy na pewno chcesz usunąć widget?": "Are you sure you want to delete the widget?",
        "Dalej": "Next",
        "Dashboard aktywny": "Active dashboard",
        "Dashboard domyślny": "Default dashboard",
        "Dashboard został dodany.": "Dashboard has been added.",
        "Dashboard został skopiowany.": "Dashboard has been copied.",
        "Dashboard został usunięty.": "Dashboard has been deleted.",
        "Dashboard został zaktualizowane.": "Dashboard has been updated.",
        "Dashboardy": "Dashboards",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data opuszczenia zespołu": "Team leave date",
        "Data otrzymania": "Date received",
        "Data rejestracji": "Registration date",
        "Data rozpoczęcia": "Start date",
        "Data uruchomienia": "Run date",
        "Data uruchomienia (UTC)": "Run date (UTC)",
        "Data usunięcia": "Deletion date",
        "Data utworzenia": "Creation date",
        "Data utworzenia wersji": "Version creation date",
        "Data użycia": "Usage date",
        "Data wygaśnięcia": "Expiration date",
        "Data wylogowania": "Logout date",
        "Data wysłania": "Send date",
        "Data zakończenia": "End date",
        "Data zalogowania": "Login date",
        "Data zdarzenia": "Event date",
        "DateTime": "DateTime",
        "Długość historii haseł": "Password history length",
        "Dni": "Days",
        "Do akceptacji": "For approval",
        "do czasu ręcznego odblokowania": "until manually unlocked",
        "Docs": "Docs",
        "Dodaj": "Add",
        "Dodaj dashboard": "Add dashboard",
        "Dodaj do zespołu": "Add to team",
        "Dodaj dział": "Add department",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "Add one or more widgets to gain insight into your team's progress.",
        "Dodaj nowy folder": "Add new folder",
        "Dodaj pliki": "Add files",
        "Dodaj rolę": "Add role",
        "Dodaj shortcode": "Add shortcode",
        "Dodaj słowo": "Add word",
        "Dodaj synonimy": "Add synonyms",
        "Dodaj szablon": "Add template",
        "Dodaj token": "Add token",
        "Dodaj typ": "",
        "Dodaj użytkownika": "Add user",
        "Dodaj wiadomość": "",
        "Dodaj widget": "Add widget",
        "Dodaj zastępstwo": "Add substitution",
        "Dodaj zespół": "Add team",
        "Dodaj zmienne dla szablonu": "Add variables for template",
        "Dodaj źródło": "Add source",
        "dodał": "added",
        "dodane i edytowane przeze mnie": "added and edited by me",
        "Dodane przez": "Added by",
        "Dodanie": "Adding",
        "Dodanie dashboardu": "Adding dashboard",
        "Dodanie działu": "Adding department",
        "Dodanie roli": "Adding role",
        "Dodanie użytkownika": "Adding user",
        "Dodanie zastępstwa": "Adding substitution",
        "Dodanie zespołu": "Adding team",
        "Dodanie źródła": "Adding source",
        "dodany": "added",
        "Dodanych plików %0 (limit wynosi %1).": "Files added %0 (limit is %1).",
        "Dokument PDF": "PDF document",
        "Dokument tekstowy": "Text document",
        "Dołącz stack trace": "Attach stack trace",
        "Domena": "Domain",
        "Domyślna": "Default",
        "Domyślne": "Default",
        "Domyślne filtry": "Default filters",
        "Domyślny": "Default",
        "Domyślny poziom logowania": "Default logging level",
        "Dostęp niezdefiniowany": "Access undefined",
        "Dostęp przyznany": "Access granted",
        "Dostęp zabroniony": "Access denied",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "A new update is available. Please save your work progress and click the \"Update\" button. You can also accept the update by refreshing the browser window. Not updating may cause errors.",
        "Double": "Double",
        "Dozwolone rozszerzenia: %0.": "Allowed extensions: %0.",
        "Dozwolone typy plików: %0.": "Allowed file types: %0.",
        "Dsn": "Dsn",
        "Duży układ siatki": "Large grid layout",
        "Dział aktywny": "Active department",
        "Dział nadrzędny": "Parent department",
        "Dział został dodany.": "Department has been added.",
        "Dział został zaktualizowany.": "Department has been updated.",
        "Działania masowe": "Bulk actions",
        "E-mail": "E-mail",
        "Edycja aranżacji dashboardu": "Dashboard arrangement edit",
        "Edycja dashboardu": "Dashboard edit",
        "Edycja działu": "Department edit",
        "Edycja logów": "Logs edit",
        "Edycja roli": "Role edit",
        "Edycja użytkownika": "User edit",
        "Edycja zastępstwa": "Substitution edit",
        "Edycja zespołu": "Team edit",
        "Edycja źródła": "Source edit",
        "Edytowana wersja": "Edited version",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Only templates of enabled and supported channels can be edited.",
        "Edytuj": "Edit",
        "Edytuj członka grupy": "Edit group member",
        "Edytuj filtr": "Edit filter",
        "Edytuj szablon": "Edit template",
        "Edytuj typ": "",
        "Edytuj uprawnienia": "Edit privileges",
        "Edytuj wiadomość": "",
        "Edytuj wpis": "Edit entry",
        "Eksport": "Export",
        "ElasticSearch": "ElasticSearch",
        "Element został przywrócony.": "Item has been restored.",
        "Element został usunięty.": "Item has been deleted.",
        "Elementy zostały usunięte.": "Items have been deleted.",
        "Email potwierdzony": "Email confirmed",
        "False": "False",
        "Filtr dla synchronizacji działów": "Filter for department synchronization",
        "Filtr dla synchronizacji użytkowników": "Filter for user synchronization",
        "Filtr domyślny": "Default filter",
        "Filtr prywatny": "Private filter",
        "Filtr został usunięty": "Filter has been deleted",
        "Filtr został zapisany": "Filter has been saved",
        "Filtry": "Filters",
        "Firebase": "Firebase",
        "Firebase config": "Firebase config",
        "Folder główny": "Main folder",
        "Folder plików": "File folder",
        "Foldery": "Folders",
        "Godziny": "Hours",
        "Grudzień": "December",
        "Grupa": "Group",
        "Harmonogram zadań": "Task schedule",
        "Harmonogram został zmieniony": "Schedule has been changed",
        "Hasło": "Password",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "Password must contain at least one special character e.g.: ~ @ # $ % ^ & *",
        "Hasło zostało zmienione. Zaloguj się ponownie": "Password has been changed. Log in again",
        "Health": "Health",
        "Historia logowania": "Login history",
        "Historia zadania": "Task history",
        "Host": "Host",
        "i": "and",
        "Id": "Id",
        "ID": "ID",
        "ID lub typ zadania": "ID or task type",
        "Id modelu: %0": "Model ID: %0",
        "Id obiektu": "Object ID",
        "Id sesji": "Session ID",
        "ID zadania": "Task ID",
        "Id zdarzenia": "Event ID",
        "Identyfikator zadania": "Task identifier",
        "Imię": "First name",
        "Imię i Nazwisko": "First and Last Name",
        "Import": "Import",
        "Import użytkowników": "User import",
        "Indeks": "Index",
        "Indeks został usunięty.": "Index has been deleted.",
        "Inspekcja": "Inspection",
        "Instalacja": "Installation",
        "Int": "Int",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "If the user is not on the list, it means that basic data such as First and Last Name is missing. Complete this data in the Users section.",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "If the field is empty, the default value is used. Otherwise, the default value is overwritten.",
        "Język": "Language",
        "Kalendarz - Kategorie zasobów": "Calendar - Resource categories",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Channel is required by default. It cannot be disabled for sending notifications via this channel. Only the title and content of the message can be changed.",
        "kanał wymagany": "required channel",
        "Kanały": "Channels",
        "Kanały komunikacji": "Communication channels",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
        "Kanały włączone w ustawieniach aplikacji": "Channels enabled in application settings",
        "Katalog został utworzony": "Catalog has been created",
        "Kategoria": "Category",
        "Key": "Key",
        "Key pair": "Key pair",
        "Klucz prywatny": "Private key",
        "Klucz publiczny": "Public key",
        "Klucze": "Keys",
        "Klucze są nie prawidłowe.": "Keys are invalid.",
        "Klucze są prawidłowe.": "Keys are valid.",
        "Kod MJML": "MJML code",
        "Kod wertfikacyjny": "Verification code",
        "Kod weryfikacyjny jest nieprawidłowy.": "Verification code is invalid.",
        "Kolejka": "Queue",
        "Kolor drugorzędny: %0": "Secondary color: %0",
        "Kolor icon na panelu z aplikacjami: %0": "Icon color on the application panel: %0",
        "Kolor podstawowy: %0": "Primary color: %0",
        "Kolor tekstu aktywnej pozycji menu: %0": "Active menu item text color: %0",
        "Kolor tła": "Background color",
        "Kolor tła panelu z aplikacjami: %0": "Application panel background color: %0",
        "Kolory zostały przywrócone.": "Colors have been restored.",
        "Kolory zostały zapisane.": "Colors have been saved.",
        "Komunikat": "Message",
        "Konfiguracja domyślna": "Default configuration",
        "Konfiguracja harmonogramu (czas UTC)": "Schedule configuration (UTC time)",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "Footer and logo configuration for notifications sent via email channel. Footer can be configured individually for each language version, logo is shared across all.",
        "Konfiguracja została zmieniona.": "Configuration has been changed.",
        "Konsola aplikacji": "Application console",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "Application console never logs from the following namespaces:",
        "Konta użytkowników zostały odblokowane": "User accounts have been unlocked",
        "Konta użytkowników zostały przypisane do zespołu": "User accounts have been assigned to the team",
        "Konta użytkowników zostały usunięte z systemu": "User accounts have been removed from the system",
        "Konta użytkowników zostały zablokowane": "User accounts have been locked",
        "Kontakt": "Contact",
        "Kontakty - Typ działania": "Contacts - Action type",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "Account will remain inactive until the email address is confirmed",
        "Konto z dostępem do panelu": "",
        "Konto zanonimizowane": "Account anonymized",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Kopiuj": "Copy",
        "Kopiuj pole": "Copy field",
        "Kosz": "Bin",
        "Kwiecień": "April",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP over SSL)",
        "Lewy panel": "Left panel",
        "Licencja": "License",
        "Liczba wyników na stronie": "Number of results per page",
        "Lider": "Leader",
        "linie": "lines",
        "Lipiec": "July",
        "Lista dozwolonych / wykluczonych żądań HTTP": "List of allowed/excluded HTTP requests",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "List of effective user privileges resulting from individual privileges and roles.",
        "Lista indeksów": "List of indices",
        "Lista jest pusta": "List is empty",
        "Lista zaufanych adresów IP": "Trusted IP address list",
        "Listopad": "November",
        "Logi wydajnościowe": "Performance logs",
        "Login": "Login",
        "Logo": "Logo",
        "Logowanie": "Login",
        "Logowanie zakończyło się niepowodzeniem.": "Login failed.",
        "Logowanie zależności / żądań typu HTTP": "Dependency / HTTP request logging",
        "Logowanie zdarzeń": "",
        "Loguj wybrane": "Log selected",
        "Long": "Long",
        "Luty": "February",
        "Ładowanie elementów...": "Loading items...",
        "Maj": "May",
        "Maksymalny rozmiar pliku: %0MB.": "Maximum file size: %0MB.",
        "Mały układ siatki": "Small grid layout",
        "Mappingi": "Mappings",
        "Marzec": "March",
        "Metoda autentykacji": "Authentication method",
        "Miesiąc": "Month",
        "Miesiące": "Months",
        "Minimalna długość hasła": "Minimum password length",
        "Minuty": "Minutes",
        "Modyfikacja": "Modification",
        "Moje dokumenty": "My documents",
        "Moje filtry": "My filters",
        "Moje konto": "My account",
        "Moje pliki": "My files",
        "Monitor kolejek": "Queue monitor",
        "Monitoring": "Monitoring",
        "Monitoring aplikacji": "",
        "Monitoruj statystyki .NET": ".NET statistics monitoring",
        "Monitoruj żądania HTTP": "HTTP request monitoring",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Modification of this section is limited. Inactive fields are synchronized with external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Modification of this account is limited. Inactive fields are synchronized with external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "Modification of this account is limited. Inactive fields are synchronized with external database %0.",
        "Mój tytuł": "My title",
        "Na pewno usunąć": "Are you sure you want to delete",
        "Nadawca": "Sender",
        "Name": "Name",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "Tool integrates with Firebase platform (push notifications)",
        "Narzędzie integruje się z platformą SMSAPI.pl": "Tool integrates with SMSAPI.pl platform",
        "Następna strona": "Next page",
        "Nazwa": "Name",
        "Nazwa aliasu": "Alias name",
        "Nazwa dashboardu": "Dashboard name",
        "Nazwa działu": "Department name",
        "Nazwa filtra": "Filter name",
        "Nazwa katalogu": "Directory name",
        "Nazwa nadawcy": "Sender name",
        "Nazwa pliku": "File name",
        "Nazwa pliku została zmieniona.": "File name has been changed.",
        "Nazwa pola": "Field name",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa roli": "Role name",
        "Nazwa szablonu": "Template name",
        "Nazwa typu": "Type name",
        "Nazwa urządzenia": "Device name",
        "Nazwa użytkownika": "Username",
        "Nazwa zadania": "Task name",
        "Nazwa zespołu": "Team name",
        "Nazwa zmiennej nie może być pusta.": "Variable name cannot be empty.",
        "Nazwa źródła": "Source name",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie loguj wybranych": "Do not log selected",
        "Nie masz uprawnień do panelu administracyjnego.": "You do not have privileges to the admin panel.",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "You do not have privileges to this view. View state may have changed, refresh and check or try again later.",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "You cannot modify the profile of the substituted user.",
        "Nie możesz modyfikować uprawnień": "You cannot modify privileges",
        "Nie można usunąć swojego konta.": "Cannot delete your own account.",
        "Nie udało się pobrać konfiguracji dashboardu": "Failed to fetch dashboard configuration",
        "Nie udało się pobrać listy działów": "Failed to fetch department list",
        "Nie udało się pobrać listy filtrów": "Failed to fetch filter list",
        "Nie udało się pobrać listy kanałów": "Failed to fetch channel list",
        "Nie udało się pobrać listy kolejek": "Failed to fetch queue list",
        "Nie udało się pobrać listy powiadomień": "Failed to fetch notification list",
        "Nie udało się pobrać listy ról": "Failed to fetch role list",
        "Nie udało się pobrać listy typów modeli": "Failed to fetch model type list",
        "Nie udało się pobrać listy wydziałów": "Failed to fetch department list",
        "Nie udało się pobrać listy zespołów": "Failed to fetch team list",
        "Nie udało się pobrać powiadomień.": "Failed to fetch notifications.",
        "Nie udało się pobrać ustawień kont użytkowników": "Failed to fetch user account settings",
        "Nie udało się pobrać widgetu/ów": "Failed to fetch widget(s)",
        "Nie udało się usunąć szablonu": "Failed to delete template",
        "Nie udało się wykonać akcji": "Failed to perform action",
        "Nie udało się wysłać pliku": "Failed to send file",
        "Nie udało się załadować elementów": "Failed to load items",
        "Nie udało się zapisać filtra": "Failed to save filter",
        "Nie udało się zapisać ustawień dashboardu": "Failed to save dashboard settings",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Not all selected items were moved. You do not have the required privileges or, in the case of moving directories, the target directory is a subdirectory of the source directory. Directories and files that could not be moved remain in the Selected tab.",
        "Nie wybrano żadnego użytkownika.": "No user selected.",
        "nie wymuszaj zmiany hasła": "do not enforce password change",
        "Nie zdefiniowano żadnych ról.": "No roles defined.",
        "Nie znaleziono filtrów.": "No filters found.",
        "Nie znaleziono kolumn.": "No columns found.",
        "Nie znaleziono pasujących elementów.": "No matching items found.",
        "Nie znaleziono właściwego widgetu": "",
        "Nie znaleziono żadnego pola.": "No field found.",
        "Nie znaleziono żadnych elementów": "No items found",
        "Nie znaleziono żadnych użytkowników.": "No users found.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nieaktywni": "Inactive",
        "niedozwolone rozszerzenie pliku (%0)": "disallowed file extension (%0)",
        "niedozwolony typ pliku (%0)": "disallowed file type (%0)",
        "Niepotwierdzeni": "Unconfirmed",
        "Nieprawidłowy adres email": "Invalid email address",
        "Nieprawidłowy adres URL": "Invalid URL",
        "Nieprzeczytane": "Unread",
        "Nieudane logowania": "Failed logins",
        "Nieznany typ pliku": "Unknown file type",
        "Nikomu nie przydzielono uprawnień": "No privileges assigned to anyone",
        "Nowe hasło": "New password",
        "np. (&(objectClass=organizationalUnit))": "e.g. (&(objectClass=organizationalUnit))",
        "np. (&(objectClass=user)": "e.g. (&(objectClass=user)",
        "Numer sesji": "Session number",
        "Numer telefonu": "Phone number",
        "OAuth2 dla Exchange Online": "OAuth2 for Exchange Online",
        "Obiekt %0 został %1": "Object %0 has been %1",
        "Obraz został wycięty.": "Image has been cropped.",
        "Oczekujące": "Pending",
        "Oczekuje na wysłanie": "Pending to send",
        "Odblokuj": "Unlock",
        "Odrzucone": "Rejected",
        "Odśwież": "Refresh",
        "Odznacz": "Uncheck",
        "Odznacz wszystkie": "Uncheck all",
        "Ok": "Ok",
        "Opis": "Description",
        "Opis zespołu": "Team description",
        "Opisy": "Descriptions",
        "Opróżnij kategorię": "Empty category",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Oraz hasło": "And password",
        "Oraz nowe hasło": "And new password",
        "Organizacja": "Organization",
        "Organizacja została usunięta.": "Organization has been deleted.",
        "Osoba zastępowana": "Substituted person",
        "Osoba zastępująca": "Substituting person",
        "Ostatnia aktywność": "Last activity",
        "Ostatnia strona": "Last page",
        "Ostrzeżenia": "Warnings",
        "Otwórz": "Open",
        "Oznacz": "Mark",
        "Oznacz jako nieprzeczytane": "Mark as unread",
        "Oznacz jako przeczytane": "Mark as read",
        "Oznacz powiadomienia": "Mark notifications",
        "Oznacz wszystkie jako przeczytane": "Mark all as read",
        "Oznacz wybrane jako nieprzeczytane": "Mark selected as unread",
        "Oznacz wybrane jako przeczytane": "Mark selected as read",
        "Paleta kolorów": "Color palette",
        "Październik": "October",
        "Pierwsza strona": "First page",
        "Plik audio": "Audio file",
        "Plik binarny": "Binary file",
        "Plik CSS": "CSS file",
        "Plik CSV": "CSV file",
        "Plik DOC": "DOC file",
        "Plik DOCX": "DOCX file",
        "Plik GIF": "GIF file",
        "Plik HTML": "HTML file",
        "Plik jest wysyłany": "File is being sent",
        "Plik JPEG": "JPEG file",
        "Plik JPG": "JPG file",
        "Plik MP4": "MP4 file",
        "Plik PNG": "PNG file",
        "Plik skompresowany": "Compressed file",
        "Plik z logami": "Log file",
        "Plik ZIP": "ZIP file",
        "Plik został wysłany": "File has been sent",
        "Pliki": "Files",
        "Pliki do wysłania: %0": "Files to send: %0",
        "Pliki współdzielone": "Shared files",
        "po %0 nieudanych próbach logowania": "after %0 failed login attempts",
        "Po jednym synonimie w wierszu": "One synonym per line",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "After selecting this option, user accounts will be removed from the system. Do you want to continue?",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "After selecting this option, individual privileges and those derived from roles are ignored.",
        "Pobierz": "Download",
        "Poczta wychodząca": "",
        "Podaj kod weryfikacyjny": "Enter verification code",
        "Podaj swój adres email": "Enter your email address",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "Creating a main administrator account is required during the first launch.",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "There was a problem saving recaptcha during login attempt. Try again",
        "Podczas przesyłania plików wystąpił nieznany błąd": "Unknown error occurred during file upload",
        "Podgląd": "Preview",
        "Podgląd HTML": "HTML preview",
        "Podgląd szablonu": "Template preview",
        "Podziedziałek - Piątek": "Monday - Friday",
        "Pokaż historię": "Show history",
        "Pokaż szczegóły": "Show details",
        "Pokaż tylko moje dokumenty": "Show only my documents",
        "Pokaż w koncie użytkownika": "Show in user account",
        "Pokaż więcej": "Show more",
        "pokaż więcej...": "show more...",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "Field \"Number of results per page\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole \"Nazwa\" jest wymagane.": "Field \"Name\" is required.",
        "Pole \"Szerokość\" jest wymagane.": "Field \"Width\" is required.",
        "Pole \"Wysokość\" jest wymagane.": "Field \"Height\" is required.",
        "Pole jest wymagane": "Field is required",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Pole skopiowane": "Field copied",
        "Polityka prywatności": "Privacy policy",
        "Polski": "Polish",
        "Poprzednia strona": "Previous page",
        "Porównaj %0": "Compare %0",
        "Porównaj z edytowaną wersją": "Compare with edited version",
        "Porównywana wersja": "Compared version",
        "Port": "Port",
        "Posiada załączniki": "Has attachments",
        "Potwierdzenia": "Confirmations",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie przywrócenia": "Restore confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie wylogowania użytkownika": "User logout confirmation",
        "Potwierdzenie zmiany statusu": "Status change confirmation",
        "Potwierdź": "Confirm",
        "Potwierdź akceptację": "Confirm approval",
        "Powiadomienia": "Notifications",
        "Powiadomienia Firebase": "",
        "Powiadomienia mailowe": "Email notifications",
        "Powiadomienia zostały skonfigurowane.": "Notifications have been configured.",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Notification is required by default. It cannot be disabled.",
        "Powiadomienie testowe zostało wysłane.": "Test notification has been sent.",
        "Powiadomienie zbiorowe zostało dodane.": "Bulk notification has been added.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Bulk notification has been updated.",
        "Powiększ kod MJML": "Expand MJML code",
        "Powiększ podgląd": "Zoom in preview",
        "Powrót": "Back",
        "Powtórz hasło": "Repeat password",
        "Powtórzone": "Repeated",
        "Pozostałe": "Others",
        "Pozostało %0 znaków.": "Remaining %0 characters.",
        "Prawy panel": "Right panel",
        "Predefiniowane tła panelu z aplikacjami": "Predefined panel backgrounds with applications",
        "Predefiniowane zestawy kolorów": "Predefined color sets",
        "Profil użytkownika": "User profile",
        "Profil został zaktualizowany.": "Profile has been updated.",
        "Prometheus": "Prometheus",
        "Próbkowanie": "Sampling",
        "Prywatny": "Private",
        "Przebudowanie indeksów": "Rebuilding indices",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Rebuilding indicesnnOperation may take from a few seconds to several hours depending on the size of indices.nnShould only be used when applying changes made in synonym or excluded word dictionaries.",
        "Przeczytane": "Read",
        "Przefiltrowani użytkownicy": "Filtered users",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "The browser you are using does not support PUSH notifications",
        "Przeindeksowanie danych": "Data reindexing",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Data reindexingnnOperation may take from a few seconds to several hours depending on the amount of data in the database.nnShould only be used when noticing missing data in indices.",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "exceeded allowed file size (%0 MB)",
        "Przeniesienie wybranych elementów": "Move selected items",
        "przeniesiony do kosza": "moved to bin",
        "Przenieś": "Move",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "Move${selected.length > 1 ? ' selected' : ''}",
        "przeniósł do kosza": "moved to bin",
        "Przepnij alias": "Switch alias",
        "Przesyłanie plików powiodło się.": "File upload succeeded.",
        "Przetestuj poprawność zapisanych kluczy": "Test saved keys validity",
        "Przetestuj ustawienia poczty": "Test mail settings",
        "Przetestuj ustawienia Sms": "Test SMS settings",
        "Przetwarzane": "Processing",
        "Przykład: domena\\użytkownik": "Example: domain\\user",
        "Przykład: użytkownik@domena": "Example: user@domain",
        "Przypisanie do zespołu": "Assign to team",
        "Przypisanie ról": "Assign roles",
        "Przywrócenie": "Restore",
        "przywrócił z kosza": "restored from bin",
        "przywrócony z kosza": "restored from bin",
        "Przywróć": "Restore",
        "Przywróć domyślne": "Restore default",
        "Przywróć filtr": "Restore filter",
        "Przyznaj dostęp": "Grant access",
        "Publiczny": "Public",
        "Ranga": "Rank",
        "ReCaptcha": "ReCaptcha",
        "Rejestr zmian": "Change log",
        "Repozytorium plików": "File repository",
        "Resetuj": "Reset",
        "Rok": "Year",
        "Rola": "Role",
        "Rola aktywna": "Active role",
        "Rola domyślna": "Default role",
        "Rola została dodana.": "Role has been added.",
        "Rola została usunięta.": "Role has been deleted.",
        "Rola została zaktualizowana.": "Role has been updated.",
        "Role i uprawnienia": "Roles and privileges",
        "Role użytkownika": "User roles",
        "Role zespołu": "Team roles",
        "Role zostały przypisane": "Roles have been assigned",
        "Root": "Root",
        "Rozmiar": "Size",
        "Rozmiar pliku": "File size",
        "Rozmiar zdjęcia został zmieniony.": "Photo size has been changed.",
        "SenderId": "SenderId",
        "Sentry": "Sentry",
        "Seq": "Seq",
        "Sesja": "Session",
        "Sesja nr %0": "Session no. %0",
        "Sesja użytkownika": "User session",
        "Sierpień": "August",
        "słowa": "words",
        "Słowa wykluczone": "Excluded words",
        "Słowo": "Word",
        "Słowo bazowe": "Base word",
        "Słowo wykluczone": "Excluded word",
        "Słowo zostało dodane.": "Word has been added.",
        "Słowo zostało usunięte.": "Word has been deleted.",
        "Słowo zostało zaktualizowane.": "Word has been updated.",
        "Stan powiadomienia": "Notification state",
        "Start": "Start",
        "Status": "Status",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status edytowanej wersji dokumentu": "Edited document version status",
        "Status powiadomienia": "Notification status",
        "Stopka": "Footer",
        "String": "String",
        "Strona główna": "Home page",
        "Struktura organizacyjna": "Organizational structure",
        "Styczeń": "January",
        "Synonimy": "Synonyms",
        "Synonimy zostały dodane.": "Synonyms have been added.",
        "Synonimy zostały usunięte.": "Synonyms have been deleted.",
        "Synonimy zostały zaktualizowane.": "Synonyms have been updated.",
        "System": "System",
        "System powiadomień": "Notification system",
        "Szablon został dodany.": "Template has been added.",
        "Szablon został usunięty.": "Template has been deleted.",
        "Szablon został zaktualizowany.": "Template has been updated.",
        "Szablony email": "",
        "Szczegóły": "Details",
        "Szczegóły zadania": "Task details",
        "Szczegóły zdarzenia": "Event details",
        "Szczegóły zdarzenia nr %0": "Event details no. %0",
        "Szerokość": "Width",
        "Szkic": "Draft",
        "Sztuczna inteligencja": "Artificial intelligence",
        "Szukaj we wszystkich wersjach": "Search in all versions",
        "Szukane słowo": "Searched word",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "This option is used to enable or disable inheritance in a given field",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "This page is protected by reCAPTCHA and Google.",
        "Tagi": "Tags",
        "Tak": "Yes",
        "Tekst alternatywny": "Alternative text",
        "Ten dashboard nie zawiera żadnych widgetów": "This dashboard does not contain any widgets",
        "Ten element nie zawiera menu kontekstowego.": "This item does not contain a context menu.",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel can send formatted text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel cannot send formatted text.",
        "Tenant ID": "Tenant ID",
        "Teraz": "Now",
        "Testowy adres email": "Test email address",
        "Testowy numer telefonu": "Test phone number",
        "Testuj": "Test",
        "Tłumaczenia": "Translations",
        "To pole jest wymagane": "This field is required",
        "Token": "Token",
        "Token został usunięty.": "Token has been deleted.",
        "Tokeny": "Tokens",
        "Tokeny dostępu": "Access tokens",
        "Tracing": "Tracing",
        "Treść": "Content",
        "True": "True",
        "Twoje hasło wygasło. Zmień je na nowe.": "Your password has expired. Change it to a new one.",
        "Twój token": "Your token",
        "Tydzień": "Week",
        "tylko dokumenty wersjonowane": "only versioned documents",
        "Tylko liderzy": "Only leaders",
        "Tylko moje": "Only mine",
        "Typ": "Type",
        "Typ konta": "Account type",
        "Typ logowania": "Login type",
        "Typ mime": "Mime type",
        "Typ obiektu": "Object type",
        "Typ pliku": "File type",
        "Typ powiadomienia": "Notification type",
        "Typ właściwy": "Proper type",
        "typu \"%0\" o ID \"%1\"": "type \"%0\" with ID \"%1\"",
        "Typy powiadomień": "",
        "Tytuł": "Title",
        "Tytuł powiadomienia": "Notification title",
        "Układ listy": "List layout",
        "Uprawnienia": "Privileges",
        "Uruchom zadanie": "Run task",
        "Urządzenie zostało usunięte.": "Device has been deleted.",
        "Ustaw domyślny poziom logowania. Logi poniżej tego poziomu nie bądą zbierane niezależnie od pozostałych ustawień.": "Set default logging level. Logs below this level will not be collected regardless of other settings.",
        "Ustaw poziomy logów które będą wysyłane do poszczególnych rejestrów.": "Set log levels to be sent to specific registers.",
        "Ustaw poziomy logów które będą zbierane z poszczególnych przestrzeni nazw.": "Set log levels to be collected from specific namespaces.",
        "Ustawienia": "Settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia powiadomień zostały zaktualizowane.": "Notification settings have been updated.",
        "Ustawienia widgetów zostały zapisane": "Widget settings have been saved",
        "Ustawienia widgetu": "Widget settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "usunął": "removed",
        "Usunął": "Removed",
        "Usunięcie": "Removal",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "Index removalnnOperation is irreversible. Are you sure you want to delete the selected index?",
        "usunięty": "deleted",
        "Usuń": "Delete",
        "Usuń dział": "Delete department",
        "Usuń filtr": "Delete filter",
        "Usuń indeks": "Delete index",
        "Usuń kolor": "Delete color",
        "Usuń plik": "Delete file",
        "Usuń plik z listy": "Delete file from list",
        "Usuń urządzenie": "Delete device",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "Delete device to revoke remembered automatic login to your account",
        "Usuń z zespołu": "Remove from team",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "Delete${selected.length > 1 ? ' selected' : ''}",
        "Usuwanie użytkowników": "User deletion",
        "Utworzył": "Created",
        "Utwórz grupy": "Create groups",
        "Utwórz katalog": "Create directory",
        "Utwórz nowy": "Create new",
        "Uwzględnij wydziały podrzędne": "Include subordinate departments",
        "Użytkownicy": "Users",
        "Użytkownicy w tej roli": "Users in this role",
        "Użytkownik": "User",
        "Użytkownik \"%0\" %1 obiekt %2": "User \"%0\" %1 object %2",
        "Użytkownik jest liderem zespołu": "User is team leader",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "User will not receive any notifications.",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "User cannot log in until account is active.",
        "Użytkownik nie należy do żadnego zespołu.": "User does not belong to any team.",
        "Użytkownik posiada pełne uprawnienia": "User has full privileges",
        "Użytkownik został dodany do zespołu.": "User has been added to team.",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został wylogowany.": "User has been logged out.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "Użytkownik został zanonimizowany.": "User has been anonymized.",
        "W każdy dzień tygodnia": "Every day of the week",
        "W organizacji nie ma jeszcze żadnych działów.": "There are no departments in the organization yet.",
        "W zespole od %0": "In team since %0",
        "W zespole od %0 do %1": "In team since %0 to %1",
        "Walidacja certyfikatu SSL": "SSL certificate validation",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "Values from 0 - 1.0 (0 means 0%, and 1 means 100%)",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "Default value: (&(objectClass=organizationalUnit))",
        "Wartość domyślna: (&(objectClass=user)": "Default value: (&(objectClass=user)",
        "Wartość musi być liczbą całkowitą": "Value must be an integer",
        "Wartość musi być liczbą dodatnią": "Value must be positive",
        "Wartość musi być liczbą ujemną": "Value must be negative",
        "Warunki korzystania z usług Google": "Google Terms of Service",
        "Ważne informacje": "Important information",
        "Wczytywanie danych...": "Loading data...",
        "Weekend": "Weekend",
        "Wersja utowrzona przez": "Version created by",
        "Wersje": "Versions",
        "Wersje dokumentu": "Document versions",
        "Wiadomość testowa została wysłana.": "Test message has been sent.",
        "Więcej": "More",
        "więcej...": "more...",
        "Właściwości": "Properties",
        "Włączone": "Enabled",
        "Włączony": "Enabled",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wpisz adresy po przecinku.": "Enter addresses separated by commas.",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "Enter URLs for services you want to exclude. Data can be separated by commas or be in a new line",
        "Wprowadzona wartość jest nieprawidłowa": "Entered value is invalid",
        "Wprowadzona wartość jest za długa": "Entered value is too long",
        "Wprowadzona wartość jest za krótka": "Entered value is too short",
        "Wprowadzona wartość jest za niska": "Entered value is too low",
        "Wprowadzona wartość jest za wysoka": "Entered value is too high",
        "Wprowadzona wartość nie jest poprawna": "Entered value is not correct",
        "Wróć do logowania": "Back to login",
        "Wróć do strony głównej": "Back to homepage",
        "Wrzesień": "September",
        "Wstaw cztery kolumny 1/4": "Insert four columns 1/4",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "Insert two columns 1/3 and 2/3",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "Insert two columns 2/3 and 1/3",
        "Wstaw dwie równe kolumny": "Insert two equal columns",
        "Wstaw szablon informacyjny ze zdjęciem": "Insert informational template with photo",
        "Wstaw trzy kolumny 1/3": "Insert three columns 1/3",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "All user's personal data in the system will be deleted!nnAre you sure you want to perform the action??",
        "Wszystko": "Everything",
        "wybierz": "select",
        "Wybierz": "Select",
        "wybierz długość": "select length",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "Select directory to move selected items.",
        "Wybierz opcję": "Select option",
        "Wybierz plik": "Select file",
        "Wybierz pliki": "Select files",
        "Wybierz pliki (do {0})": "Select files (up to {0})",
        "Wybierz shortcode": "Select shortcode",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select notification type to see available keys.",
        "Wybierz użytkownika": "Select user",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select users for whom you want to perform actions",
        "Wybierz zaznaczone": "Select selected",
        "wybierz...": "select...",
        "Wybór języka": "Language selection",
        "Wybrane": "Selected",
        "Wybrane elementy zostały przeniesione.": "Selected items have been moved.",
        "Wybrane elementy zostały usunięte.": "Selected items have been deleted.",
        "wybrane elementy?": "selected items?",
        "Wybrane pliki": "Selected files",
        "Wybrane pliki: {0}": "Selected files: {0}",
        "Wybrane: %0": "Selected: %0",
        "wybranego elementu": "selected item",
        "Wybrano %0 użytkowników.": "Selected %0 users.",
        "Wybrano jednego użytkownika.": "Selected one user.",
        "Wybrany element został usunięty.": "Selected item has been deleted.",
        "wybrany element?": "selected item?",
        "wybranych elementów": "selected items",
        "Wydział": "Department",
        "Wyklucz logowanie zależności": "Exclude dependency logging",
        "Wykonaj": "Execute",
        "Wyloguj się": "Log out",
        "Wyloguj zalogowanego obecnie użytkownika": "Log out currently logged-in user",
        "Wyłaczone": "Disabled",
        "Wyłączone wysyłanie powiadomień": "Disabled notification sending",
        "Wyłączony": "Disabled",
        "Wymagaj znaków specjalnych w hasłach": "Require special characters in passwords",
        "Wymagane": "Required",
        "Wymagane jest ustawienie minimalnej długości hasła": "Setting minimum password length is required",
        "Wymiary": "Dimensions",
        "Wymuś zmianę hasła": "Force password change",
        "Wysłane": "Sent",
        "Wysokość": "Height",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "Error occurred while loading image. Try again.",
        "Wystąpił błąd podczas próby exportu użytkowników.": "Error occurred during user export attempt.",
        "Wystąpił błąd podczas próby importu użytkowników.": "Error occurred during user import attempt.",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Connection error. Ensure internet is enabled and try again.",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Server error occurred during selected operation. Try again.",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Unknown server error occurred during selected operation. Try again.",
        "Wystąpiły błędy podczas zapisywania formularza": "Errors occurred while saving form",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Errors in form. Check all form fields.",
        "Wysyłaj dane o użytkowniku": "Send user data",
        "Wysyłaj tym kanałem": "Send via this channel",
        "Wysyłka wiadomości": "",
        "Wyszukaj (Ctrl+Q)": "Search (Ctrl+Q)",
        "wyszukaj użytkownika...": "search user...",
        "Wyszukaj widget": "Search widget",
        "Wyszukaj...": "Search...",
        "Wyszukiwanie": "Searching",
        "Wyślij": "Send",
        "Wyślij do": "Send to",
        "Wyślij kod": "Send code",
        "Wyświetlam": "Displaying",
        "Wytnij": "Cut",
        "Zaakceptowany": "Accepted",
        "Zabierz dostęp": "Revoke access",
        "Zablokowany": "Blocked",
        "Zablokuj": "Block",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "Index rebuild task has started.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "Data reindexing task has started.",
        "Zadanie zostało uruchomione.": "Task has been started.",
        "Zadanie zostało włączone": "Task has been enabled",
        "Zadanie zostało wyłączone": "Task has been disabled",
        "Zaimportowano listę użytkowników.": "User list has been imported.",
        "Zakolejkowane": "Queued",
        "Zakończ sesję": "End session",
        "Zakończ sesję aby wylogować użytkownika": "End session to log out user",
        "Zakończone": "Finished",
        "Zaloguj się": "Log in",
        "Zaloguj się na swoje konto": "Log in to your account",
        "Zamknij": "Close",
        "Zapamiętaj logowanie": "Remember login",
        "Zapamiętane urządzenia": "Remembered devices",
        "Zapisz": "Save",
        "Zapisz aranżację": "Save arrangement",
        "Zapisz filtr": "Save filter",
        "Zapisz i wróć": "Save and back",
        "Zapisz ustawienia": "Save settings",
        "Zapisz widget": "Save widget",
        "Zapisz zmiany": "Save changes",
        "Zaplanowane": "Scheduled",
        "Zapomniałeś hasła?": "Forgot password?",
        "Zastępstwa": "Substitutions",
        "Zastępstwo": "Substitution",
        "Zastępstwo wygasło.": "Substitution has expired.",
        "Zastępstwo wygaśnie za 10 minut.": "Substitution will expire in 10 minutes.",
        "Zastępstwo wygaśnie za 5 minut.": "Substitution will expire in 5 minutes.",
        "Zastępstwo wygaśnie za minutę.": "Substitution will expire in a minute.",
        "Zastępstwo zostało dodane.": "Substitution has been added.",
        "Zastępstwo zostało usunięte.": "Substitution has been deleted.",
        "Zastępstwo zostało zaktualizowane.": "Substitution has been updated.",
        "Zastępuje osobę": "Replaces person",
        "Zaufane adresy IP": "Trusted IP addresses",
        "Zawiera": "Contains",
        "Zaznacz": "Select",
        "Zaznacz wszystkie": "Select all",
        "Zbieranie i przechowywanie logów": "Log collection and storage",
        "Zdarzenie": "Event",
        "Zdjęcie użytkownika": "User photo",
        "Zespoły": "Teams",
        "Zespół": "Team",
        "Zespół aktywny": "Active team",
        "Zespół został dodany.": "Team has been added.",
        "Zespół został usunięty.": "Team has been deleted.",
        "Zespół został zaktualizowany.": "Team has been updated.",
        "Zmiana hasła": "Password change",
        "Zmiana rozmiaru obrazu": "Image resizing",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "Changing settings may result in loss of access to panel!nnAre you sure you want to save changes??",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "Monitoring settings changes require application restart.",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "Changes will take effect only after index rebuild.",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmienne": "Variables",
        "Zmień hasło": "Change password",
        "Zmień nazwę": "Rename",
        "Zmień nazwę katalogu": "Rename directory",
        "Zmień nazwę pliku": "Rename file",
        "Zmień rozmiar": "Resize",
        "Zmień status edytowanej wersji": "Change status of edited version",
        "Zmień widok": "Change view",
        "zmodyfikował": "modified",
        "Zmodyfikował": "Modified",
        "zmodyfikowany": "modified",
        "znaki": "characters",
        "Zobacz przed opublikowaniem": "View before publishing",
        "Zobacz sesję użytkownika": "View user session",
        "Zobacz szczegóły sesji użytkownika": "View user session details",
        "Zobacz szczegóły zdarzenia": "View event details",
        "Zobacz wszystkie": "View all",
        "Zobacz wszystkie zastępstwa": "View all substitutions",
        "Został przywrócony oryginalny harmonogram": "Original schedule has been restored",
        "Zresetuj hasło": "Reset password",
        "Zrestartuj aplikacje": "Restart application",
        "Zwrócony": "Returned",
        "Źródła LDAP": "LDAP sources",
        "Źródła logów": "Log sources",
        "Źródło": "Source",
        "Źródło aktywne": "Active source",
        "Źródło LDAP zostało dodane.": "LDAP source has been added.",
        "Źródło LDAP zostało zaktualizowane.": "LDAP source has been updated.",
        "Źródło zostało usunięte.": "Source has been deleted.",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No communication channel has been enabled in notification settings."
    }
};
